import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NotificationModalContextType {
  openCardModal: (clienteId: string) => void;
  openGestorModal: () => void;
  isCardModalOpen: boolean;
  isGestorModalOpen: boolean;
  selectedClienteId: string | null;
  closeCardModal: () => void;
  closeGestorModal: () => void;
}

const NotificationModalContext = createContext<NotificationModalContextType | undefined>(undefined);

export const useNotificationModal = () => {
  const context = useContext(NotificationModalContext);
  if (!context) {
    throw new Error('useNotificationModal deve ser usado dentro de NotificationModalProvider');
  }
  return context;
};

interface NotificationModalProviderProps {
  children: ReactNode;
}

export const NotificationModalProvider: React.FC<NotificationModalProviderProps> = ({ children }) => {
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isGestorModalOpen, setIsGestorModalOpen] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState<string | null>(null);

  const openCardModal = (clienteId: string) => {
    setSelectedClienteId(clienteId);
    setIsCardModalOpen(true);
  };

  const openGestorModal = () => {
    setIsGestorModalOpen(true);
  };

  const closeCardModal = () => {
    setIsCardModalOpen(false);
    setSelectedClienteId(null);
  };

  const closeGestorModal = () => {
    setIsGestorModalOpen(false);
  };

  return (
    <NotificationModalContext.Provider
      value={{
        openCardModal,
        openGestorModal,
        isCardModalOpen,
        isGestorModalOpen,
        selectedClienteId,
        closeCardModal,
        closeGestorModal,
      }}
    >
      {children}
    </NotificationModalContext.Provider>
  );
};
